export default __webpack_public_path__ + "static/media/checked.58c2e146.svg";